import styled from '@emotion/styled';
import React from 'react';
import { typography } from '../../styles/typography';

const TextHost = styled.p<{ variant: string }>`
  ${(props) => typography[props.variant]}
`;

export interface IProps {
  as?: React.ElementType;
  variant?: keyof typeof typography;
}

export const Text: React.FC<IProps> = ({
  as = 'p',
  variant = 'body',
  children,
}) => {
  return (
    <TextHost as={as} variant={variant}>
      {children}
    </TextHost>
  );
};
